//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk'; 

export default {
  components: {
      cmBlank,cmLoadmore, wx
  },
  data () {
    return {
      blankShow:false,
      loadStatus:false,
      popBg:false,
      loadmoreText:'正在加载。。。',
      busy:false,
      code1:'',
      code:'',
      pageFlag:2,
      hasNext:0,
      lastId:0,
      list:[],
    }
  },
  created(){
    this.config();
    this.search();
    
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    reset(){
        this.code = '';
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    create(){
       this.code1 = '';
       this.popBg = true;
    },
    getList(){
        this.$api.clothesSearch({code:this.code}).then((res)=>{
            if(res){
                console.log(res);
                if(!this.lastId){
                    this.blankShow = res.data.length > 0 ? false : true;
                }
                // this.hasNext = res.hasNext;
                // this.lastId = res.lastId;
                // res.data.forEach((item)=>{
                //     this.list.push(item);
                // });
                this.list = res.data;
            }
        }) 
    },
    barOrder(code){
        this.$router.push({name:'barOrder',params:{code:code}})
    },
    abnormal(code){
        this.$router.push({name:'abnormal',params:{code:code}})
    },
    remove (index) {
        const id = this.list[index].id;
        this.$func.confirm('确认删除？','提示',()=>{
            this.$func.startLoading();
            this.$api.removeClothesSearch({id:id}).then((res)=>{
                if(res){
                    this.list.splice(index,1);
                    this.$func.endLoading();
                    this.$func.showToast('操作成功');
                } 
            })   
      })
    },
    submitClothesSearch () {
        if(!this.code1){
            this.$func.showToast('请输入衣物编码');
            return false;
        }
        this.$func.startLoading();
        this.$api.submitClothesSearch({code:this.code1}).then((res)=>{
            if(res){
                this.reset();
                this.popBg = false;
                this.$func.endLoading();
            } 
      })  
    },
    scanQRCode(i){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ['barCode'],
            success: function (res) {
                setTimeout(()=>{
                    // that.code = res.resultStr.split(',')[1];
                    if(i > 0){
                        that.code1 = res.resultStr.split(',')[1];
                    }else{
                        that.code = res.resultStr.split(',')[1];
                        that.search();
                    }
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/clothesSearch.vue